import { useEffect, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import { STATUS, STATUS_ORDEM, formatarReal } from './financeiroUtils';

// Barra única que divide o faturado nos 4 status, em proporção real.
// Se receber `onSelecionar`, cada trecho vira um botão que filtra por status.
export default function BarraSemaforo({ valores, altura = 14, selecionado = null, onSelecionar, animar = true }) {
  const [montado, setMontado] = useState(!animar);

  // Única animação de entrada da tela: os trechos crescem a partir do zero.
  useEffect(() => {
    if (!animar) return undefined;
    const id = requestAnimationFrame(() => setMontado(true));
    return () => cancelAnimationFrame(id);
  }, [animar]);

  const total = STATUS_ORDEM.reduce((soma, s) => soma + Number(valores?.[s] || 0), 0);
  const raio = altura / 2;

  if (!total) {
    return <Box sx={{ height: altura, borderRadius: `${raio}px`, backgroundColor: '#eef1f5' }} />;
  }

  const interativo = Boolean(onSelecionar);

  return (
    <Box
      role="group"
      aria-label="Distribuição do faturado por situação"
      sx={{
        display: 'flex', gap: '2px', height: altura, borderRadius: `${raio}px`,
        overflow: 'hidden', backgroundColor: '#eef1f5',
      }}
    >
      {STATUS_ORDEM.filter((s) => Number(valores[s] || 0) > 0).map((s) => {
        const valor = Number(valores[s]);
        const pct = (valor / total) * 100;
        const ativo = selecionado === s;
        const apagado = Boolean(selecionado) && !ativo;
        const texto = `${STATUS[s].label}: ${formatarReal(valor)} (${pct.toFixed(1).replace('.', ',')}%)`;
        return (
          <Tooltip key={s} title={texto} arrow>
            <Box
              component={interativo ? 'button' : 'div'}
              type={interativo ? 'button' : undefined}
              onClick={interativo ? () => onSelecionar(ativo ? null : s) : undefined}
              aria-pressed={interativo ? ativo : undefined}
              aria-label={texto}
              sx={{
                flexGrow: montado ? pct : 0, flexShrink: 1, flexBasis: 0, minWidth: 6,
                p: 0, m: 0, border: 0, appearance: 'none',
                backgroundColor: STATUS[s].cor, opacity: apagado ? 0.28 : 1,
                cursor: interativo ? 'pointer' : 'default',
                transition: 'flex-grow 900ms cubic-bezier(0.2, 0.8, 0.2, 1), opacity 200ms ease',
                '&:focus-visible': { outline: '2px solid #1a1a2e', outlineOffset: '-2px' },
                '@media (prefers-reduced-motion: reduce)': { transition: 'opacity 200ms ease' },
              }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
}
